import {all, put, takeLatest, select} from 'redux-saga/effects';
import {handleError, executeAxiosWithExceptionHandling, handleAxiosException} from "./index";
import axios from "axios";
import {push} from 'react-router-redux';


function* fetchRewards() {
    try {
        let state = yield select();
        let response = yield executeAxiosWithExceptionHandling(() => axios.get(`/hotdeals/rest/rewards?lang=${state.language.currentLanguage}`));

        yield put({
            type: 'REWARDS_FETCHED',
            rewards: response.data
        })

    }catch(error){
        yield handleError(error, error.response && error.response.status === 404 ? 'rewards.notFound' : null);
    }
}

function* fetchReward(action) {
    try {
        let state = yield select();

        let response = yield axios.get(`/hotdeals/rest/rewards/${action.friendlyName}?lang=${state.language.currentLanguage}`);

        yield put({
            type: 'REWARD_FETCHED',
            reward: response.data
        })

    }catch(exception){
        if (exception && exception.response && exception.response.status === 404) {
            yield put({
                type: 'REWARD_NOT_FOUND'
            })
        }else{
            handleAxiosException(exception);
        }
    }
}

function* redirectToRewardDetail(action){
    yield put(push('/'.concat(action.friendlyName)));
}

export default function* rewardsSaga() {
    yield all([
        takeLatest('FETCH_REWARDS', fetchRewards),
        takeLatest('REWARD_CARD_CLICKED', redirectToRewardDetail),
        takeLatest('FETCH_REWARD', fetchReward)
    ]);
}